module.exports = __webpack_public_path__ + "img/paint-09.2042d3a8.png";